import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PartnerContactService } from './services/partner-contact.service';
import { PartnerContactType } from './models/partner-contact-type';
import { CurrentUserService } from '../user/services/current-user.service';
import { ToastService, ToastType } from '../shared/toast/toast.service';
import { SvgIconComponent } from '../shared/icons/svg-icon.component';
import { PermissionRequiredDirective } from '../shared/authentication/permission-required.directive';
import { ChangeLogLinkComponent } from '../shared/change-log/change-log-link/change-log-link.component';
import { ChangeLogLinkEntityDirective } from '../shared/change-log/change-log-link-entity/change-log-link-entity.directive';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../shared/grid/biz-grid.directive';
import { DxoEditingModule, DxiColumnModule, DxiValidationRuleModule } from 'devextreme-angular/ui/nested';
import { GridService } from '../shared/grid/grid.service';

@Component({
    templateUrl: './partner-contact-types.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, PermissionRequiredDirective, ChangeLogLinkComponent, ChangeLogLinkEntityDirective, DxDataGridModule, BizDataGridDirective, DxoEditingModule, DxiColumnModule, DxiValidationRuleModule]
})

export class PartnerContactTypesComponent implements OnInit {

    private gridService = inject(GridService);
    private partnerContactService = inject(PartnerContactService); 
    private currentUserService = inject(CurrentUserService);
    private toastService = inject(ToastService);
    
    public contactTypes: PartnerContactType[] = [];
    public isLoading: boolean;

    public allowUpdating = false;
    public allowAdding = false;
    public allowDeleting = false;

    ngOnInit(): void {
        this.checkPermissions();
        void this.refresh();
    }

    checkPermissions() {
        this.allowUpdating = this.currentUserService.hasPermission('Partner_Action_ContactTypeEdit');
        this.allowAdding = this.currentUserService.hasPermission('Partner_Action_ContactTypeEdit');
        this.allowDeleting = this.currentUserService.hasPermission('Partner_Action_ContactTypeDelete');
    }

    public async refresh() {
        await this.loadContactTypes();
    }

    async loadContactTypes() {
        this.isLoading = true;
        this.contactTypes = await this.partnerContactService.getContactTypes();
        this.isLoading = false;
    }

    initNewContactTypeRow(e: any) {
        e.data = { Id: null };
    }

    onRowRemoving = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as PartnerContactType, item => this.removeContactTypeRow(item));
    };

    async removeContactTypeRow(partnerContactType: PartnerContactType) : Promise<PartnerContactType> {
        await this.partnerContactService.deleteContactType(partnerContactType.Id)
        this.toastService.showToast('Contact Type deleted...', ToastType.success);
        return partnerContactType;
    }

    async handleContactTypeSave(e: any) {
        try {
            const partnerContactTypeToSave = (e.data || e.key) as PartnerContactType;
            const savedType = await this.partnerContactService.saveContactType(partnerContactTypeToSave);
            partnerContactTypeToSave.Id = savedType.Id;
            this.toastService.showToast('Contact Type Saved', ToastType.success);
        }
        catch (err) {
            console.error(err);
            this.toastService.showToast('Failed to save contact type ...', ToastType.error);
        }
    }
}
